import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, Input } from '@angular/core';
import { BillingService } from '../../../services/billing.service';
import { AppService } from '../../../services/app.service';
import { BillingInterface, PlanInterface, UserInterface } from 'voxr-shared';
import { UserService } from '../../../services/user.service';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-setup-billing',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule, MatProgressBarModule, MatButtonModule, MatIconModule,
    PlanCardComponent
  ],
  templateUrl: './setup-billing.component.html',
  styleUrl: './setup-billing.component.scss'
})
export class SetupBillingComponent {
  private userService = inject(UserService);
  private billingService = inject(BillingService);
  private app = inject(AppService);

  planId = input<string | undefined>(undefined);
  @Input() showSetup = true;
  @Input() addCrm?: boolean;

  loading = true;
  user?: UserInterface;
  billing?: BillingInterface;
  private _allPlans?: PlanInterface[];
  plans?: PlanInterface[];

  constructor() {
    effect(() => {
     this.plans = this.planId() ? this._allPlans?.filter(p => p._id?.toString() === this.planId()) : this._allPlans;
    }); 
  }

  async ngOnInit() {
    const user = await this.userService.current();
    if (user) await this.load(user);
  }

  async load(user: UserInterface) {
    try {
      this.loading = true;
      this.user = user;
      this._allPlans = this.plans = await this.billingService.plans();
      if (this.planId()) this.plans = this.plans?.filter(p => p._id?.toString() === this.planId());
      this.billing = user._metadata?.billing as BillingInterface;
    } catch (error: any) {
      this.app.message$.next({ severity: 'danger', summary: 'Error', detail: error.message });
    } finally {
      this.loading = false;
    }
  }

  settingBilling = false;
  async setupBillingAccount() {
    this.settingBilling = true;
    try {
      await this.billingService.checkout();
    } catch (error: any) {
      this.app.message$.next({ severity: 'danger', summary: 'Error', detail: error.message });
    } finally { this.settingBilling = false; }
  }

  async checkoutPlan(planId: string) {
    this.settingBilling = true;
    try {
      if (this.billing?.customerId)
        await this.billingService.subscribe(planId);
      else
        await this.billingService.checkout(planId, this.addCrm);
    } catch (error: any) {
      this.app.message$.next({ severity: 'danger', summary: 'Error', detail: error.message });
    } finally { this.settingBilling = false; }
  }
}
